<template>
    <div class="border pd-10 mb-5">
        <span class="mr-5">
            <span v-for="(p, index) in path" :key="index">
                <span :class="{ 'color-theme bolder': index === 0 }">{{ p }}</span>
                /
            </span>
            <span>{{ $route.query.carrierName }}</span>
        </span>
        <i class="el-icon-tickets cursor-pointer" @click="toCarrierDetail"></i>
    </div>
</template>

<script>
import { carrierDetail } from '@/utils/winDetail';
import { getFullPath } from '@/api/modules/public';

export default {
    props: ['carrierId', 'carrierName', 'carrierType'],
    data() {
        return {
            fullPath: ''
        };
    },
    computed: {
        path() {
            const path = this.$route.query.fullPath || this.fullPath || '';
            return path.split('/');
        }
    },
    methods: {
        toCarrierDetail() {
            const { carrierType, carrierId, carrierName, type } = this.$route.query;
            carrierDetail(carrierId, carrierName, carrierType || type);
        }
    },
    mounted() {
        const { carrierId, fullPath } = this.$route.query;
        // 没有提供通过接口去获取
        if (!fullPath) {
            getFullPath(carrierId).then(({ result }) => {
                this.fullPath = result.fullPath;
                this.$emit('onFullPath', this.fullPath);
            });
        } else {
            this.$emit('onFullPath', fullPath);
        }
    }
};
</script>
